<template>
  <div class="antialiased overflow-hidden">
    <NavBar />
    <main>
      <router-view v-if="connected"/>
      <div v-else>
        <loading-icon />
      </div>
    </main>
  </div>
</template>

<script lang="ts">
import NavBar from '@/components/NavBar.vue'
import LoadingIcon from '@/components/LoadingIcon.vue'
import useRadix from '@/composables/useRadix'
import { onMounted, defineComponent } from 'vue'

export default defineComponent({
  name: 'Home',
  components: {
    LoadingIcon,
    NavBar
  },

  setup () {
    const { connected, establishConnection } = useRadix()

    onMounted(establishConnection)

    return { connected }
  }
})
</script>
